module.exports = __webpack_public_path__ + "static/media/custom-10.4cfbce24.svg";